import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BillingPlan } from './billing.service';

export interface AdminOrganization {
  id: string;
  name: string;
  customerStatus: string;
  plan: BillingPlan | { id: string; name: string } | null;
  subscriptionStatus: string | null;
}

export interface AdminOrganizationsResponse {
  organizations: AdminOrganization[];
  plans: BillingPlan[];
}

export interface GrantSubscriptionRequest {
  planId: string;
  status?: string;
}

export interface GrantSubscriptionResponse {
  customer: { id: string; name: string };
  plan: BillingPlan;
  status: string;
}

/**
 * Cross-organization super-admin API (see backend/src/routes/admin.ts).
 * Only reachable by users with is_super_admin set on the global users table.
 */
@Injectable({ providedIn: 'root' })
export class AdminService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getOrganizations(): Observable<AdminOrganizationsResponse> {
    return this.http.get<AdminOrganizationsResponse>(`${this.apiUrl}/admin/organizations`);
  }

  grantSubscription(customerId: string, request: GrantSubscriptionRequest): Observable<GrantSubscriptionResponse> {
    return this.http.post<GrantSubscriptionResponse>(
      `${this.apiUrl}/admin/organizations/${customerId}/subscription`,
      request,
    );
  }
}
